







import { Component, Watch, Vue } from 'vue-property-decorator';
import Header from '@/components/Header.vue';

@Component({
  components: {
    Header,
  },
})
export default class AppContent extends Vue {
    private created() {
        window.addEventListener('keyup', (e) => {
            if (e.keyCode === 37) {
                window.history.back();
            } else if (e.keyCode === 39) {
                window.history.forward();
            }
        });
    }
}
